import { DS_SPACING_UNITS } from '@calm/evexia-design-tokens';
import {
    MediaPack,
    MediaPackGuide,
    MediaPackProgram,
} from '@calm/evexia-web-sdk';
import { dailyPracticeCardWidth } from '@rhg/components/discover-dailies/daily-packs';
import { PackGuideCard } from '@rhg/components/pack-guide-card';
import { PackProgramCard } from '@rhg/components/pack-program-card';
import { Box } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { useEffect, useState } from 'react';
import { MAX_CENTERED_ITEMS, styleCardFooter } from '..';
import { PackDetailsPaddedContainer } from '../layout';

interface PackPageGridSectionProps {
    pack?: MediaPack;
}

const styleFlexGrid = {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: DS_SPACING_UNITS.CONTENT,
    rowGap: DS_SPACING_UNITS.SECTION,
};

const styleCenterGrid = {
    justifyContent: 'center',
};

export const PackPageGridSection = ({ pack }: PackPageGridSectionProps) => {
    const [centerGridItems, setCenterGridItems] = useState(false);

    // Default - account for program cards view all
    useEffect(() => {
        if (
            (pack?.items?.length ?? Number.POSITIVE_INFINITY) <=
            MAX_CENTERED_ITEMS
        ) {
            setCenterGridItems(true);
        }
    }, [pack?.items?.length]);

    return (
        <PackDetailsPaddedContainer>
            <Box
                sx={sxAppend(styleFlexGrid, centerGridItems && styleCenterGrid)}
            >
                {pack?.items.map((packItem) => {
                    if ('guideId' in packItem) {
                        return (
                            <PackGuideCard
                                key={packItem?.guideId}
                                willLockIfUnsponsored
                                packClass={pack?.packClass ?? ''}
                                variant="carouselSquare"
                                packGuide={packItem as MediaPackGuide}
                                sx={{ width: dailyPracticeCardWidth }}
                                contentSx={styleCardFooter}
                            />
                        );
                    } else if ('programId' in packItem) {
                        return (
                            <PackProgramCard
                                key={packItem?.programId}
                                packClass={pack?.packClass ?? ''}
                                variant="carouselSquare"
                                packProgram={packItem as MediaPackProgram}
                                sx={{ width: dailyPracticeCardWidth }}
                                contentSx={styleCardFooter}
                            />
                        );
                    } else {
                        return null;
                    }
                })}
            </Box>
        </PackDetailsPaddedContainer>
    );
};
